import { LitElement, html, css, unsafeHTML } from 'https://cdn.jsdelivr.net/gh/lit/dist@3/all/lit-all.min.js'

/**
 * Skio Universal Plan Picker
 * @docs https://integrate.skio.com/
 *
 * Uses LitJS (<5kb) https://lit.dev/ for reactive web components
 */

export class SkioPlanPicker extends LitElement {
  static properties = {
    key: { type: String },

    product: { type: Object },
    productHandle: { type: String },
    selectedVariant: { type: Object },

    options: { type: Object },

    moneyFormat: { type: String },

    quantity: { type: Number },
    rules: { type: Array },
    rule: { type: Object },
    cart: { type: Object },

    availableSellingPlanGroups: { state: true },
    selectedSellingPlanGroup: { type: Object },
    selectedSellingPlan: { type: Object },

    disableUrl: { type: Boolean },

    debug: { type: Boolean },
  }

  static styles = [
    css`
        :host {
            width: 100%;
            max-width: 440px;
        }

        .skio-plan-picker {
            display: flex;
            gap: 1rem;
            padding: 2rem 1rem 0 1rem;
            border: 0;
            font-size: 15px;
            color: black;
            width: 100%;
            margin: 0;
            font-family: inherit;
            box-sizing: border-box;
            background-color: var(--product-background-color);
        }
        @media(max-width: 767px){
            .skio-plan-picker {
                min-width: 100vw;
                margin-left: -1rem;
            }
        }
        @media(min-width: 768px){
            .skio-plan-picker {
                border-radius: 1rem 1rem 0 0;
                padding: 24px 24px 0 24px;
            }
        }
        
        .skio-plan-picker .icons {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            gap: 1rem;
            margin-top: 18px;
        }
        .skio-plan-picker .icons .icon {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            gap: 6px;
        }

        :host([layout='hidden']) .skio-plan-picker {
            display: none;
        }

        :host([layout='vertical']) .skio-plan-picker {
            flex-direction: column;
        }

        :host([layout='horizontal']) .skio-plan-picker {
            flex-direction: row;
            flex-wrap: wrap;
        }

        .sr-only {
            position: absolute;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            width: 1px;
            height: 1px;
            margin: -1px;
            padding: 0;
            border: 0;
        }

        .group-container {
            display: block;
            position: relative;
            transition: border-color 0.2s ease;
            border: var(--skio-group-border-width, 1px) solid var(--skio-group-border-color, #ccc);
            border-radius: var(--skio-group-border-radius, 0);
            background-color: var(--skio-group-background-color, transparent);
            color: var(--skio-group-text-color, #000);
            border-radius: 12px;
        }

        .group-container--selected {
            border-color: var(--skio-group-border-selected-color, #333);
            color: var(--skio-group-text-selected-color, #000);
        }

        .group-container--last {
            order: 1;
        }

        :host([layout='horizontal']) .group-container {
            width: calc(50% - 0.5rem - calc(2 * var(--skio-group-border-width, 1px)));
        }

        .group-input {
            position: absolute;
            opacity: 0;
            width: 0px;
            height: 0px;
        }

        .group-input:focus-visible ~ .group-label {
            outline: 2px #ccc solid;
            outline-offset: 4px;
        }

        .group-heading {
            background-color: var(--skio-group-border-color, #ccc);
            color: #ffffff;
            font-weight: 700;
            font-size: 18px;
            padding: 0 11px;
            text-align: center;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            border-radius: 10px 10px 0 0;
        }

        .group-label {
            display: flex;
            flex-direction: column;
            padding: 10px;
            cursor: pointer;
        }

        .group-topline {
            display: flex;
            align-items: center;
            width: 100%;

            gap: 8px;
        }

        .group-container--selected .group-topline {
            font-weight: 700;
        }

        :host([layout='horizontal']) .group-topline {
            flex-direction: column;
            text-align: center;
        }

        .skio-radio__container {
            display: flex;
            color: var(--skio-group-border-color, #333);
        }
        fieldset .group-container:nth-child(3) .skio-radio__container {
            margin-top: 3px;
            margin-bottom: auto;
        }

        .group-container--selected .skio-radio__container {
            color: var(--skio-group-border-selected-color, #333);
        }

        .skio-radio {
            transform-origin: center;
            opacity: 0;
            transform: scale(0);
            transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .group-label:hover .skio-radio {
            opacity: 0.75;
            transform: scale(1);
        }

        .group-container--selected .group-label .skio-radio {
            opacity: 1;
            transform: scale(1);
        }

        .skio-price {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            text-align: right;
            gap: 12px;

            line-height: 1;

            margin-left: auto;
            vertical-align: middle;

            font-weight: 500;
            color: #040404;
            font-size: 16px;
        }
          @media(min-width: 768px){
          .skio-price {
            font-size: 18px;
          }
        }

        .skio-price s {
          font-weight: 400;
          opacity: 0.75;
          color: #5D5D5D;
        }
        

        :host([layout='horizontal']) .skio-price {
            text-align: center;
            margin-right: auto;
        }

        .group-content {
            display: flex;
            flex-direction: column;
            opacity: 1;
            width: auto;
            max-height: 1000px;
            transition: max-height 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .group-content.margin-left {
          margin: 0;
        }

        .group-content p {
            margin: 0.5rem 0 0 0;
            font-size: 13px;
            color: #000;
        }

        :host([layout='horizontal']) .group-content {
            width: 100%;
        }

        /* Hide frequency if not selected */
        .group-container:not(.group-container--selected) .group-content {
            pointer-events: none;
            opacity: 0;
            max-height: 0;
            visibility: hidden;
        }

        :host([layout='horizontal']) .group-container:not(.group-container--selected) + .group-content {
            pointer-events: none;
            opacity: 0;
            max-height: 0;
            visibility: hidden;
        }

        .group-title {
            width: 100%;
            max-width: 70%;
            line-height: 1.5;
            font-size: 18px;
            font-weight: bold;
        }

        :host([layout='horizontal']) .group-title {
            max-width: 100%;
        }

        .savings {
            color: var(--skio-discount-text-color, #fff);
        }

        .savings.bubble {
            padding: 5px 16px;
            padding: 2px 12px;
            width: fit-content;
            background-color: var(--skio-discount-color, #0fa573);
            border: 1px var(--skio-discount-color, #0fa573) solid;
            border-radius:50px;
            font-size: 14px;
            font-weight: 700;
            color: var(--skio-discount-text-color, #fff);

            white-space: nowrap;
        }

        .selling-plan-dropdown {
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            display: flex;
            align-items: center;
            gap: 5px;
            width: 100%;
            margin-top: 5px;
            padding: 8px 30px 8px 10px;
            background-color: #ffffff;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-position: right 10px top 50%;
            background-size: 16px;
            border: 1px solid rgba(0,0,0,0.05);
            border-radius: 8px;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            padding: 12px 30px 12px 16px;
            font-weight: bold;
        }

        .selling-plan-dropdown-label {
            color: #666666;
            font-weight: 500;
        }

        .selling-plan-dropdown--one {
            background-image: none;
            pointer-events: none;
            background: transparent;
        }

        .selling-plan-buttons {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(var(--skio-button-plan-selector-width, 20px), 1fr));
            gap: 10px;
            padding: 0.75rem 0;
            border: 0;
            font-size: 13px;
        }

        .selling-plan-buttons input[type='radio'] {
            position: absolute;
            opacity: 0;
            width: 0;
            height: 0;
        }

        .selling-plan-buttons label {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border: 1px solid #ccc;
            text-align: center;
            padding: 1rem 0.5rem;
        }

        .selling-plan-buttons input[type='radio']:checked + label {
            border-color: #000;
        }

        .selling-plan-buttons input:focus-visible + label {
            outline: 2px #ccc solid;
            outline-offset: 4px;
        }

        .group-content-additional {
            margin-top: 5px;
        }

        .skio-details {
            --text-color: #333;
            --text-color-secondary: #888;

            user-select: none;
            -webkit-user-select: none;
            margin-bottom: 20px;
            order: 3;
            max-width: max-content;
        }

        .skio-details summary::-webkit-details-marker,
        .skio-details summary::marker,
        .skio-details slot {
            color: rgba(0, 0, 0, 0) !important;
        }

        .skio-details summary {
            margin-top: 15px;
        }

        .skio-details summary span {
            font-size: 0.9em;
            display: flex;
            padding: 0.5em 0;
            cursor: pointer;
            align-items: center;
            gap: 10px;
            text-decoration: underline;

            margin-top: -40px;
            color: #000;
        }

        @keyframes fadeInDown {
            0% {
            opacity: 0;
            transform: translateY(-15px);
            }
            100% {
            opacity: 1;
            transform: translateY(0px);
            }
        }
        .skio-details[open] > .skio-details--content {
            animation-name: fadeInDown;
            animation-duration: 0.3s;
        }

        .skio-details--content {
            position: absolute;
            z-index: 1020;
            padding: 1em;
            width: fit-content;
            border-radius: 5px;
            background: white;
            box-shadow: 0 0 5px rgb(23 24 24 / 5%), 0 1px 2px rgb(0 0 0 / 7%);
        }

        .skio-details ul {
            margin: 0;
            padding: 0;
        }

        .skio-details ul li {
            display: flex;
            align-items: flex-start;
            gap: 0.75em;

            margin-bottom: 1em;
        }

        .skio-details .skio-content {
            display: flex;
            flex-direction: column;
        }

        .skio-details .skio-content p {
            font-size: 0.9em;

            margin-top: 0;
            margin-bottom: 0;

            letter-spacing: 0;
            line-height: 1.5;

            color: var(--text-color);
        }

        .skio-details ul li small {
            font-size: 0.7em;
            color: var(--text-color-secondary);
        }

        .skio-details .skio-icon {
            display: flex;

            width: 2.25em;
            height: 2.25em;

            color: var(--text-color);
            background: #f8f8f8;
            border-radius: 100%;

            flex-shrink: 0;
            align-items: center;
            justify-content: center;
        }

        .skio-details .skio-icon svg {
            width: 1.25em;
            height: 1.25em;

            color: inherit;
        }

        .skio-details--footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 0.9em;
        }

        .skio-details--footer a {
            color: var(--text-color);
        }

        .skio-manage-link {
            text-decoration: underline;
        }

        .powered-by-skio {
            font-size: 0.8em;

            display: flex;
            text-decoration: none;

            align-items: center;
            gap: 3px;
        }

        .setupMode {
            position: relative;
            color: black;
            padding: 1rem;
            display: flex;
            flex-direction: column;
            gap: 10px;
            margin-bottom: 1rem;
            font-size: 14px;
            border-style: solid;
            border-width: 4px;
            border-image: repeating-linear-gradient(-55deg, #000, #000 20px, #ffb101 20px, #ffb101 40px) 10;
        }

        .setupMode:after {
            content: 'Setup Mode';
            position: absolute;
            top: 0;
            right: 0;
            background-color: black;
            color: white;
            padding: 0.25rem 1rem;
            font-size: 13px;
        }

        .setupMode .detection {
            display: grid;
            grid-template-columns: auto 1fr;
            gap: 10px;
        }

        .setupMode .detection small {
            grid-column: 1/-1;
        }
    `,
  ]

  constructor() {
    super()
    // Start - Debug Variables
    this.debug = this.debug || window?.Shopify?.designMode
    this.variantChanged = false
    // End - Debug Variables

    this.rules = []
    this.rule = null
    this.quantity = 1
    this.showDetailsHover = false
  }

  async connectedCallback() {
    super.connectedCallback()

    this.log('Mounted')

    if (this.productHandle) {
      this.loading = true
      this.fetchProduct(this.productHandle)
    }

    this.bindFormEvents()
    this.bindCartEvents()

    this.rules = await this.fetchRules()
    await this.getRule()
  }

  // SECTION: Element Templates
  radioTemplate() {
    return html`
      <div class="skio-radio__container">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
          <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
        </svg>
      </div>
    `
  }

  sellingPlanDropdown(group) {
    return html`
      <select
        class="selling-plan-dropdown ${this.getAvailableSellingPlans(group).length == 1 ? 'selling-plan-dropdown--one' : ''}"
        @change=${e => {
          this.selectSellingPlan(e.target.value)
        }}
      >
        ${group
          ? this.getAvailableSellingPlans(group).map(
              selling_plan => html` <option ?selected=${group.selected_selling_plan.id === selling_plan.id} value=${selling_plan.id}>${selling_plan.name}</option> `
            )
          : ''}
      </select>
    `
  }

  sellingPlanButtons(group) {
    return html`
      <fieldset class="selling-plan-buttons">
        <legend class="sr-only">Select subscription interval</legend>
        ${group
          ? this.getAvailableSellingPlans(group).map(
              selling_plan => html`
                <input
                  type="radio"
                  name="selling_plan_button"
                  value="${selling_plan}"
                  id="selling_plan_button-${selling_plan.id}"
                  @change="${e => this.selectSellingPlan(selling_plan.id)}"
                  ?checked=${group.selected_selling_plan === selling_plan}
                />

                <label for="selling_plan_button-${selling_plan.id}"> ${selling_plan.name} </label>
              `
            )
          : ''}
      </fieldset>
    `
  }

  invalidIcon() {
    return html`
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#D22B2B" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    `
  }

  validIcon() {
    return html`
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#0BDA51" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    `
  }

  setupMode() {
    return html`
      <div class="setupMode">
        Skio Plan Picker
        <small>This will not appear on the live site.</small>

        <small>Key: ${this.key}</small>

        <div class="detection">${this.product ? this.validIcon() : this.invalidIcon()} Product</div>

        <div class="detection">${this.selectedVariant ? this.validIcon() : this.invalidIcon()} Selected Variant</div>

        <div class="detection">${this.form ? this.validIcon() : this.invalidIcon()} Form</div>

        <div class="detection">${this.variantInput ? this.validIcon() : this.invalidIcon()} Variant Input</div>

        <div class="detection">
          ${this.variantChanged ? this.validIcon() : this.invalidIcon()} Variant Change Detection
          <small>Please attempt to change the selected variant.</small>
        </div>

        <small>If any of these don't pass please troubleshoot using our <a target="_blank" rel="noreferrer" href="https://integrate.skio.com/troubleshooting">troubleshooting guide</a>.</small>
      </div>
    `
  }

  groupContent(group) {
    return html`
      <div class="group-content ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector && this.options?.dropdownPosition == 'inside' ? 'margin-left' : ''}">
        <span class="selling-plan-dropdown-label">${this.additionalFrequencyLabel()}</span>
        ${this.options?.selector_type == 'dropdown' ? this.sellingPlanDropdown(group) : ''}

        <!-- TODO: Make the label have the border instead of the group -->
        ${this.options?.selector_type == 'button' ? this.sellingPlanButtons(group) : ''} ${this.additionalContentText()}
      </div>
    `
  }

  showDetails() {
    return html`
      <details class="skio-details" @mouseover=${e => this.detailsMouseover()} @mouseleave=${e => this.detailsMouseleave()}>
        <summary>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="ai ai-ArrowRepeat"
            >
              <path d="M18 2l3 3-3 3" />
              <path d="M6 22l-3-3 3-3" />
              <path d="M21 5H10a7 7 0 0 0-7 7" />
              <path d="M3 19h11a7 7 0 0 0 7-7" />
            </svg>

            How do subscriptions work?
          </span>
        </summary>
        <div class="skio-details--content">
          <ul>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <div class="skio-content">
                <p>Get exclusive deals</p>
                <small>Subscribe for unique discounts</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                </svg>
              </div>
              <div class="skio-content">
                <p>Edit your subscription anytime</p>
                <small>Edit products, delivery schedule and more</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>

              <div class="skio-content">
                <p>No commitment</p>
                <small>Easy to cancel if it’s not for you</small>
              </div>
            </li>
          </ul>
          <div class="skio-details--footer">
            <a class="skio-manage-link" href="/a/account/login">Manage subscriptions</a>

            <a style="letter-spacing: 0" class="powered-by-skio" href="https://skio.com/?utm_source=eonsincshop.myshopify.com&utm_medium=details_popover" target="_blank" rel="noopener">
              Powered by
              <svg width="24" height="11" viewBox="0 0 24 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.28399 5.78801C4.12399 5.63601 3.93599 5.50801 3.71999 5.40401C3.50399 5.30001 3.27599 5.24801 3.03599 5.24801C2.85199 5.24801 2.67999 5.28401 2.51999 5.35601C2.36799 5.42801 2.29199 5.55201 2.29199 5.72801C2.29199 5.89601 2.37599 6.01601 2.54399 6.08801C2.71999 6.16001 2.99999 6.24001 3.38399 6.32801C3.60799 6.37601 3.83199 6.44401 4.05599 6.53201C4.28799 6.62001 4.49599 6.73601 4.67999 6.88001C4.86399 7.02401 5.01199 7.20001 5.12399 7.40801C5.23599 7.61601 5.29199 7.86401 5.29199 8.15201C5.29199 8.52801 5.21599 8.84801 5.06399 9.11201C4.91199 9.36801 4.71199 9.57601 4.46399 9.73601C4.22399 9.89601 3.95199 10.012 3.64799 10.084C3.34399 10.156 3.03999 10.192 2.73599 10.192C2.24799 10.192 1.76799 10.116 1.29599 9.96401C0.831989 9.80401 0.443989 9.57201 0.131989 9.26801L1.23599 8.10401C1.41199 8.29601 1.62799 8.45601 1.88399 8.58401C2.13999 8.71201 2.41199 8.77601 2.69999 8.77601C2.85999 8.77601 3.01599 8.74001 3.16799 8.66801C3.32799 8.58801 3.40799 8.45201 3.40799 8.26001C3.40799 8.07601 3.31199 7.94001 3.11999 7.85201C2.92799 7.76401 2.62799 7.67201 2.21999 7.57601C2.01199 7.52801 1.80399 7.46401 1.59599 7.38401C1.38799 7.30401 1.19999 7.19601 1.03199 7.06001C0.871989 6.92401 0.739989 6.75601 0.635989 6.55601C0.531989 6.35601 0.479989 6.11601 0.479989 5.83601C0.479989 5.47601 0.555989 5.17201 0.707989 4.92401C0.859989 4.66801 1.05599 4.46001 1.29599 4.30001C1.53599 4.14001 1.79999 4.02401 2.08799 3.95201C2.38399 3.87201 2.67599 3.83201 2.96399 3.83201C3.41199 3.83201 3.84799 3.90401 4.27199 4.04801C4.70399 4.18401 5.06799 4.39201 5.36399 4.67201L4.28399 5.78801Z"
                  fill="black"
                />
                <path d="M12.8481 10H10.4121L8.45615 7.13201H8.42015V10H6.44015V0.928009H8.42015V6.44801H8.45615L10.3641 4.02401H12.7521L10.4481 6.72401L12.8481 10Z" fill="black" />
                <path
                  d="M15.7009 2.11601C15.7009 2.26801 15.6689 2.41201 15.6049 2.54801C15.5489 2.67601 15.4689 2.78801 15.3649 2.88401C15.2689 2.98001 15.1489 3.05601 15.0049 3.11201C14.8689 3.16801 14.7249 3.19601 14.5729 3.19601C14.2529 3.19601 13.9849 3.09201 13.7689 2.88401C13.5529 2.66801 13.4449 2.41201 13.4449 2.11601C13.4449 1.97201 13.4729 1.83601 13.5289 1.70801C13.5849 1.57201 13.6649 1.45601 13.7689 1.36001C13.8729 1.26401 13.9929 1.18801 14.1289 1.13201C14.2649 1.06801 14.4129 1.03601 14.5729 1.03601C14.7249 1.03601 14.8689 1.06401 15.0049 1.12001C15.1489 1.17601 15.2689 1.25201 15.3649 1.34801C15.4689 1.44401 15.5489 1.56001 15.6049 1.69601C15.6689 1.82401 15.7009 1.96401 15.7009 2.11601ZM13.5889 10V4.02401H15.5569V10H13.5889Z"
                  fill="black"
                />
                <path
                  d="M23.4516 6.98801C23.4516 7.47601 23.3636 7.92001 23.1876 8.32001C23.0116 8.71201 22.7716 9.04801 22.4676 9.32801C22.1636 9.60001 21.8116 9.81201 21.4116 9.96401C21.0116 10.116 20.5836 10.192 20.1276 10.192C19.6796 10.192 19.2516 10.116 18.8436 9.96401C18.4436 9.81201 18.0916 9.60001 17.7876 9.32801C17.4916 9.04801 17.2556 8.71201 17.0796 8.32001C16.9036 7.92001 16.8156 7.47601 16.8156 6.98801C16.8156 6.50001 16.9036 6.06001 17.0796 5.66801C17.2556 5.27601 17.4916 4.94401 17.7876 4.67201C18.0916 4.40001 18.4436 4.19201 18.8436 4.04801C19.2516 3.90401 19.6796 3.83201 20.1276 3.83201C20.5836 3.83201 21.0116 3.90401 21.4116 4.04801C21.8116 4.19201 22.1636 4.40001 22.4676 4.67201C22.7716 4.94401 23.0116 5.27601 23.1876 5.66801C23.3636 6.06001 23.4516 6.50001 23.4516 6.98801ZM21.5556 6.98801C21.5556 6.79601 21.5236 6.60801 21.4596 6.42401C21.3956 6.24001 21.3036 6.08001 21.1836 5.94401C21.0636 5.80001 20.9156 5.68401 20.7396 5.59601C20.5636 5.50801 20.3596 5.46401 20.1276 5.46401C19.8956 5.46401 19.6916 5.50801 19.5156 5.59601C19.3396 5.68401 19.1916 5.80001 19.0716 5.94401C18.9596 6.08001 18.8716 6.24001 18.8076 6.42401C18.7516 6.60801 18.7236 6.79601 18.7236 6.98801C18.7236 7.18001 18.7516 7.36801 18.8076 7.55201C18.8716 7.73601 18.9636 7.90401 19.0836 8.05601C19.2036 8.20001 19.3516 8.31601 19.5276 8.40401C19.7036 8.49201 19.9076 8.53601 20.1396 8.53601C20.3716 8.53601 20.5756 8.49201 20.7516 8.40401C20.9276 8.31601 21.0756 8.20001 21.1956 8.05601C21.3156 7.90401 21.4036 7.73601 21.4596 7.55201C21.5236 7.36801 21.5556 7.18001 21.5556 6.98801Z"
                  fill="black"
                />
              </svg>
            </a>
          </div>
        </div>
      </details>
    `
  }

  // !SECTION: Element Templates

  render() {
    if (!this.viable() || this.options?.layout === 'hidden') {
      return this.debug ? this.setupMode() : ''
    }

    if (this.selectedVariant.selling_plan_allocations.length === 0 && !this.options?.show_without_subscription) {
      return this.debug ? this.setupMode() : ''
    }

    return html`
      ${this.debug ? this.setupMode() : null}

      <fieldset class="skio-plan-picker" role="radiogroup" aria-labelledby="skio-plan-picker-legend">
        <legend id="skio-plan-picker-legend" class="${!this.options?.show_legend ? 'sr-only' : ''}">${unsafeHTML(this.options?.legend_content)}</legend>

        ${!this.product.requires_selling_plan
          ? html`
              <div
                class="group-container ${this.selectedSellingPlanGroup == null ? 'group-container--selected' : ''} ${!this.options?.onetime_first ? 'group-container--last' : ''}"
                @click=${() => this.selectSellingPlanGroup(null)}
              >
                <input
                  id="one-time-${this.key}"
                  class="group-input"
                  name="skio-group-${this.key}"
                  type="radio"
                  value="One time purchase"
                  ?checked=${!this.selectedSellingPlanGroup}
                  @change=${() => this.selectSellingPlanGroup(null)}
                />

                <label class="group-label" for="one-time-${this.key}">
                  <div class="group-topline">
                    ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector ? this.radioTemplate() : ''}

                    <div class="group-title">${this.options?.onetime_title ? this.options?.onetime_title : 'One time purchase'}</div>

                    <div class="skio-price" aria-live="polite">
                      ${this.options?.show_compare_price && this.selectedVariant?.compare_at_price > this.selectedVariant.price
                        ? html`<s aria-hidden="true">${this.money(this.selectedVariant.compare_at_price)}</s>`
                        : ''}
                      ${this.money(this.selectedVariant.price)}
                    </div>
                  </div>
                </label>
              </div>
            `
          : ''}
        ${this.availableSellingPlanGroups?.length
          ? this.availableSellingPlanGroups.map(
              (group, index) => html`
                <div class="group-container ${this.selectedSellingPlanGroup == group ? 'group-container--selected' : ''}">
                  <input
                    id="group-${index}-${this.key}"
                    class="group-input"
                    name="skio-group-${this.key}"
                    type="radio"
                    value="${group.id}"
                    @change=${() => this.selectSellingPlanGroup(group)}
                    ?checked=${this.selectedSellingPlanGroup == group}
                  />
                  <div class="group-heading">Best Value - Save ${group.selected_selling_plan.price_adjustments[0].value}% Every Delivery</div>

                  <label class="group-label" for="group-${index}-${this.key}">
                    <div class="group-topline">
                      ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector ? this.radioTemplate() : ''}

                      <div class="group-title">
                        ${group.name !== 'Prepaid' && this.options?.subscription_title
                          ? this.options?.subscription_title
                          : group.name == 'Prepaid' && this.options?.prepaid_title
                          ? this.options?.prepaid_title
                          : group.name}
                        ${this.discountText(group.selected_selling_plan)
                          ? html` <div class="savings ${this.options?.discount_style}"> ${this.discountText(group.selected_selling_plan)} </div> `
                          : html``}
                      </div>

                      <div class="skio-price" aria-live="polite">
                        ${this.options?.show_compare_price &&
                        (this.selectedVariant?.compare_at_price > this.selectedVariant.price || this.selectedVariant.price > this.price(group.selected_selling_plan, false))
                          ? html`<s aria-hidden="true">${this.money(this.selectedVariant.compare_at_price ? this.selectedVariant.compare_at_price : this.selectedVariant.price)}</s>`
                          : ''}
                        ${this.price(group.selected_selling_plan)}
                      </div>
                    </div>

                    ${this.options?.layout == 'vertical' && this.options?.dropdownPosition == 'inside' ? this.groupContent(group) : ''}

                    <div class="icons">
                        <div class="icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <rect width="24" height="24" fill="url(#pattern0_467_5491)"/>
                                <defs>
                                <pattern id="pattern0_467_5491" patternContentUnits="objectBoundingBox" width="1" height="1">
                                <use xlink:href="#image0_467_5491" transform="scale(0.00195312)"/>
                                </pattern>
                                <image id="image0_467_5491" width="512" height="512" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
                                </defs>
                            </svg>

                            <span>Get ${group.selected_selling_plan.price_adjustments[0].value}% off every repeat delivery</span>
                        </div>
                        <div class="icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 7C4 5.58579 4 4.87868 4.43934 4.43934C4.87868 4 5.58579 4 7 4C8.41421 4 9.12132 4 9.56066 4.43934C10 4.87868 10 5.58579 10 7V17C10 18.4142 10 19.1213 9.56066 19.5607C9.12132 20 8.41421 20 7 20C5.58579 20 4.87868 20 4.43934 19.5607C4 19.1213 4 18.4142 4 17V7Z" stroke="#0B0B0B" stroke-width="1.5"/>
                                <path d="M14 7C14 5.58579 14 4.87868 14.4393 4.43934C14.8787 4 15.5858 4 17 4C18.4142 4 19.1213 4 19.5607 4.43934C20 4.87868 20 5.58579 20 7V17C20 18.4142 20 19.1213 19.5607 19.5607C19.1213 20 18.4142 20 17 20C15.5858 20 14.8787 20 14.4393 19.5607C14 19.1213 14 18.4142 14 17V7Z" stroke="#0B0B0B" stroke-width="1.5"/>
                            </svg>
                            <span>Pause or Cancel Anytime</span></div>
                        <div class="icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <rect width="24" height="24" fill="url(#pattern0_467_5492)"/>
                                <defs>
                                <pattern id="pattern0_467_5492" patternContentUnits="objectBoundingBox" width="1" height="1">
                                <use xlink:href="#image0_467_5492" transform="scale(0.00195312)"/>
                                </pattern>
                                <image id="image0_467_5492" width="512" height="512" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
                                </defs>
                            </svg>
                            <span>Free AU shipping after the first order</span>
                        </div>
                    </div>

                  </label>
                </div>
                ${this.selectedSellingPlanGroup == group ? (this.options?.layout == 'horizontal' || this.options?.dropdownPosition == 'underneath' ? this.groupContent(group) : '') : ''}
              `
            )
          : ''}
        ${this.options?.show_details == true ? this.showDetails() : ''}
      </fieldset>
    `
  }

  async fetchRules() {
    if (sessionStorage.getItem('skio-discount-rules')) {
      return JSON.parse(sessionStorage.getItem('skio-discount-rules'))
    } else {
      const rules = await fetch(`https://api.skio.com/storefront-http/get-rules-by-domain-or-hostname?domain=${window?.Shopify?.shop}`)
        .then(response => response.json())
        .then(response => {
          return response.rules.filter(rule => rule.type !== 'surpriseDelight').sort((a, b) => a.minQuantityToDiscount - b.minQuantityToDiscount)
        })

      sessionStorage.setItem('skio-discount-rules', JSON.stringify(rules))
      return rules
    }
  }

  eligibleItemCount(rule) {
    const eligibleQuantity = rule?.productVariantIds.some(gid => gid.includes(this.selectedVariant.id)) ? this.quantity : 0

    if (!this.cart?.items) return eligibleQuantity

    const cartItems = Number(
      this.cart?.items.reduce(
        (aggregate, item) =>
          rule?.productVariantIds.some(gid => gid.includes(item.id) && item.selling_plan_allocation && gid.includes(this.selectedVariant.id)) ? aggregate + item.quantity : aggregate,
        0
      )
    )

    return cartItems + eligibleQuantity
  }

  getRule() {
    let largestMinQuantity = {
      value: -1,
      index: -1,
    }

    this.rules.forEach((rule, index) => {
      if (rule.code && largestMinQuantity.value < rule.minQuantityToDiscount) {
        if (rule.minQuantityToDiscount <= this.eligibleItemCount(rule)) {
          largestMinQuantity.value = rule.minQuantityToDiscount
          largestMinQuantity.index = index
        }
      }
    })

    this.rule = largestMinQuantity.index > -1 ? this.rules[largestMinQuantity.index] : null
  }

  bindCartEvents() {
    document.addEventListener('CartUpdated', event => {
      this.cart = event.detail
    })
  }

  bindFormEvents() {
    this.form = document.querySelector(`#${this.options?.form_id}`) || this.closest('form[action*="/cart/add"]')

    if (!this.form) {
      return
    }

    this.variantInput = this.form.querySelector('[name="id"]')

    if (this.variantInput) {
      this.variantInput.addEventListener('change', e => {
        this.selectedVariant = this.product.variants.find(variant => variant.id == e.target.value)
        this.variantChanged = true
      })
      // this.form.addEventListener('change', e => {
      //   this.selectedVariant = this.product.variants.find(variant => variant.id == this.variantInput.value)
      //   this.variantChanged = true
      // })
    }

    const $quantityInput = this.form.querySelector('[name="quantity"]')

    if ($quantityInput) {
      this.quantity = Number($quantityInput.value)
      $quantityInput.addEventListener('input', () => {
        this.quantity = Number($quantityInput.value)
      })
    }
  }

  detailsMouseover() {
    let details = this.renderRoot.querySelector('.skio-details')
    let summary = this.renderRoot.querySelector('.skio-details summary')
    if (!details.hasAttribute('open') && this.showDetailsHover == false) {
      summary.click()
      this.showDetailsHover = true
    }
  }

  detailsMouseleave() {
    let details = this.renderRoot.querySelector('.skio-details')
    let summary = this.renderRoot.querySelector('.skio-details summary')
    if (details.hasAttribute('open') && this.showDetailsHover == true) {
      summary.click()
      this.showDetailsHover = false
    }
  }

  updated(changed) {
    if (!this.viable()) return

    if (changed.has('product') && this.product) {
      this.key = this.key ? this.key : this.product.id
    }

    if (changed.has('selectedVariant') && this.selectedVariant) {
      const filteredSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group =>
          selling_plan_group.app_id === 'SKIO' && !selling_plan_group.name.toLowerCase().includes('hidden-') && !selling_plan_group.name.toLowerCase().includes('dynamic box subscription')
      )

      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = filteredSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id)
        )
      )

      if (this.options?.combine_groups) {
        this.availableSellingPlanGroups = [
          {
            name: this.options?.combined_group_name,
            selling_plans: this.availableSellingPlanGroups.flatMap(group => group.selling_plans),
            id: 'combined_group',
            app_id: 'SKIO',
          },
        ]
      }

      // TODO: Select proper group depending on what selling plan is selected

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length) {
        const url = new URL(window.location.href)
        const urlSelectedSellingPlanId = url.searchParams.get('selling_plan')

        //update each group with a default selected_selling_plan
        this.availableSellingPlanGroups.forEach(group => {
          const availableSellingPlans = this.getAvailableSellingPlans(group)

          const urlSelectedSellingPlan = availableSellingPlans.find(plan => plan.id == urlSelectedSellingPlanId)
          const nameSelectedSellingPlan = availableSellingPlans.find(plan => plan.name === this.selectedSellingPlan?.name)
          const defaultSellingPlan =
            this.options?.default_subscription && this.options.default_subscription.trim() !== ''
              ? availableSellingPlans.find(plan => plan.name.toLowerCase().includes(this.options.default_subscription.toLowerCase()))
              : null

          group.selected_selling_plan = urlSelectedSellingPlan || nameSelectedSellingPlan || defaultSellingPlan || availableSellingPlans[0]

          const isAnyPlanSelected = urlSelectedSellingPlan || nameSelectedSellingPlan || defaultSellingPlan

          group.selected = !!isAnyPlanSelected
        })

        if ((!this.variantChanged && this.options?.start_onetime == false) || this.product.requires_selling_plan == true || urlSelectedSellingPlanId || this.selectedSellingPlan) {
          let selectedSellingPlanGroup = this.availableSellingPlanGroups.find(group => group.selected) || this.availableSellingPlanGroups[0]
          let selectedSellingPlanId = selectedSellingPlanGroup.selected_selling_plan.id
          this.selectSellingPlan(selectedSellingPlanId)
        } else {
          this.selectSellingPlanGroup(null)
        }
      } else {
        this.selectSellingPlanGroup(null)
      }
    }

    if (changed.has('selectedSellingPlan')) {
      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true,
        composed: true,
        detail: {
          variant: this.selectedVariant,
          sellingPlan: this.selectedSellingPlan,
          key: this.key,
        },
      })

      this.dispatchEvent(event)

      this.dispatchEvent(
        new CustomEvent('change', {
          detail: { value: this.selectedSellingPlan?.id },
        })
      )
    }

    this.updateForm()
    this.updateExternalPrice()

    if (!this.disableUrl) {
      this.updateURLParams()
    }

    if (changed.has('quantity')) {
      this.getRule()
    }

    if (changed.has('cart')) {
      this.getRule()
    }

    this.updateExternalElements()
  }

  updateExternalElements() {
    document.querySelectorAll(`[skio-price][skio-key="${this.key}"]`).forEach(el => {
      el.innerHTML = this.price(this.selectedSellingPlan)
    })

    document.querySelectorAll(`[skio-subscription-content]`).forEach(el => {
      el.style.display = this.selectedSellingPlan ? 'block' : 'none'
    })
  }

  // SECTION: Utility Functions
  log(...args) {
    args.unshift(`%c[skio plan picker][${this.key}]`, 'color: #8770f2;')
    console.log.apply(console, args)
  }

  error(...args) {
    args.unshift(`%c [skio plan picker][${this.key}]`, 'color: #ff0000')
    console.error.apply(console, args)
  }

  appendOrdinalSuffix(num) {
    const j = num % 10,
      k = num % 100
    if (j == 1 && k != 11) {
      return num + 'st'
    }
    if (j == 2 && k != 12) {
      return num + 'nd'
    }
    if (j == 3 && k != 13) {
      return num + 'rd'
    }
    return num + 'th'
  }

  viable() {
    const errors = []

    const sellingPlanInput = this.querySelector('input[name=selling_plan]')
    if (!sellingPlanInput) {
      errors.push('Missing selling plan input')
    }

    if (!this.product) {
      errors.push('No product found. Please pass a product or productHandle to the skio-plan-picker component.')
    }
    if (!this.selectedVariant) {
      errors.push('No variant found. Please pass a product or productHandle to the skio-plan-picker component.')
    }
    if (!this.form) {
      errors.push('No form found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id".')
    }
    if (!this.variantInput) {
      errors.push('No variant input found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id"')
    }

    if (errors.length == 0) return true

    this.error('Errors', errors)
    return false
  }

  getAvailableSellingPlans(group) {
    let availableSellingPlans = group.selling_plans.filter(selling_plan =>
      this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id)
    )

    return availableSellingPlans
  }

  // !SECTION: Utility Functions

  updateCTAPrice() {
    if (typeof updatePrice === 'function'){
      window.sellingPlan = this.selectedSellingPlan
      updatePrice()
    }
  }
  // Update selected selling plan group; called on click of group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group
    this.selectedSellingPlan = group?.selected_selling_plan
    
    this.updateCTAPrice()
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(selling_plan_id) {
    const selectedGroup = this.availableSellingPlanGroups.find(group => group.selling_plans.some(plan => plan.id == selling_plan_id))
    const selectedSellingPlan = selectedGroup.selling_plans.find(plan => plan.id == selling_plan_id)

    selectedGroup.selected_selling_plan = selectedSellingPlan
    this.selectedSellingPlanGroup = selectedGroup
    this.selectedSellingPlan = selectedSellingPlan
    
    this.updateCTAPrice()
  }

  updateExternalPrice() {
    document.querySelectorAll(this.options?.external_price_selector).forEach(el => {
      this.selectedSellingPlan ? (el.innerHTML = this.price(this.selectedSellingPlan)) : (el.innerHTML = this.money(this.selectedVariant.price))
    })
  }

  additionalFrequencyLabel() {
    if (!this.options?.additional_frequency_label || this.options?.additional_frequency_label == '') return

    return unsafeHTML(this.options?.additional_frequency_label)
  }

  additionalContentText() {
    if (!this.options?.additional_subscription_content || this.options?.additional_subscription_content == '') return

    return html`
      <div class="group-content-additional">
        ${unsafeHTML(
          this.options?.additional_subscription_content
            .replaceAll(
              '[discount]',
              this.options?.discount_format === 'absolute' ? this.money(this.discount(this.selectedSellingPlan).absolute) : this.discount(this.selectedSellingPlan).percent + '%'
            )
            .replaceAll('[future_price_adjustments]', this.postCheckoutDiscountsText(this.selectedSellingPlan) || '')
        )}
      </div>
    `
  }

  // SECTION: Discount Functions
  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discountText(selling_plan) {
    const discount = this.discount(selling_plan)
    const hasInvalidDiscount = Object.values(discount).some(value => value === 0 || value === Infinity || value.toString().includes('-'))

    if (hasInvalidDiscount) {
      return '' // Return empty if any invalid condition is met
    } else {
      return unsafeHTML(
        this.options?.discount_text
          .replaceAll('[discount]', this.options?.discount_format === 'absolute' ? this.money(discount.absolute) : discount.percent + '%')
          .replaceAll('[future_price_adjustments]', this.postCheckoutDiscountsText(selling_plan) || '')
      )
    }
  }

  discount(selling_plan) {
    if (!selling_plan) return { percent: 0, amount: 0 }
    return this.getDiscountFromPriceAdjustment(selling_plan, selling_plan.price_adjustments[0])
  }

  postCheckoutPriceAdjustments(selling_plan) {
    const { price_adjustments } = selling_plan
    const postCheckoutPriceAdjustments = price_adjustments.filter(({ position }) => position !== 1)
    const discounts = postCheckoutPriceAdjustments.map(price_adjustment => this.getDiscountFromPriceAdjustment(selling_plan, price_adjustment))
    return discounts
  }

  postCheckoutDiscountsText(sellingPlan = this.selectedSellingPlan) {
    if (!sellingPlan || !this.options?.future_price_adjustments_text || this.future_price_adjustments_text == '') return

    const postCheckoutPriceAdjustments = this.postCheckoutPriceAdjustments(sellingPlan)
    if (!postCheckoutPriceAdjustments.length) return

    return postCheckoutPriceAdjustments.map((discount, index) =>
      this.options?.future_price_adjustments_text
        .replaceAll('[discount]', this.options?.discount_format === 'absolute' ? this.money(discount.absolute) : discount.percent + '%')
        .replaceAll('[order_count]', index + 1)
        .replaceAll('[order_count_ordinal]', this.appendOrdinalSuffix(index + 1))
    )
  }

  getDiscountFromPriceAdjustment(selling_plan, price_adjustment) {
    const discount = {
      percent: 0,
      amount: 0,
      absolute: 0,
    }

    let multiplier = 1

    let sellingPlanGroup = this.product.selling_plan_groups.find(group => group.selling_plans.some(plan => plan.id == selling_plan.id))

    if (sellingPlanGroup?.name === 'Prepaid') {
      const str = selling_plan.name // replace with your string
      const intervalDate = /\b\d+\s*(days|weeks|months|years)\b/gi
      const intervalDateMatches = str.match(intervalDate)

      if (intervalDateMatches?.length) {
        const intervals = intervalDateMatches[0].match(/\d+/g)
        multiplier = intervals[0] / (intervals[1] || 1)
        multiplier = multiplier > 1 ? multiplier : 1
      }
    }

    const price = this.selectedVariant.price
    const compareAtPrice = this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > price ? this.selectedVariant.compare_at_price : price

    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = price_adjustment.value
        discount.absolute = Math.round((price * price_adjustment.value) / 100.0)
        discount.amount = Math.round((price * price_adjustment.value) / 100.0)
        break
      case 'fixed_amount':
        discount.percent = Math.round(((price_adjustment.value * 1.0) / price) * 100.0)
        discount.absolute = price_adjustment.value
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = Math.round((((compareAtPrice * multiplier - price_adjustment.value) * 1.0) / (compareAtPrice * multiplier)) * 100.0)
        discount.absolute = compareAtPrice * multiplier - price_adjustment.value
        discount.amount = price - price_adjustment.value
        break
    }

    return discount
  }

  /**
   * Formats a number of cents into a currency string using Shopify format string.
   *
   * https://help.shopify.com/en/manual/international/pricing/currency-formatting#currency-formatting-options
   *
   * Originally from: https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
   *
   * @param cents - The number of cents to format.
   * @param formatString - The format string to use.
   * @returns The formatted currency string.
   */
  // money(cents, formatString = this.moneyFormat) {
  money(cents, formatString = window.money_format) {
    const placeholderRegex = /{{\s*(\w+)\s*}}/

    /**
     * Formats a number of cents into a currency string using the provided
     * precision, thousands separator, and decimal separator.
     * @param number - The number of cents to format.
     * @param precision - The number of decimal places to include.
     * @param thousands - The character to use as the thousands separator.
     * @param decimal - The character to use as the decimal separator.
     * @returns The formatted currency string.
     */
    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) {
        return '0'
      }

      const numString = (number / 100.0).toFixed(precision)
      const parts = numString.split('.')
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
      const cents = parts[1] ? decimal + parts[1] : ''
      return dollars + cents
    }

    return formatString.replace(placeholderRegex, (match, placeholder) => {
      switch (placeholder) {
        case 'amount':
          // Ex.	1,134.65
          return formatWithDelimiters(cents, 2)
        case 'amount_no_decimals':
          // Ex. 1,135
          return formatWithDelimiters(cents, 0)
        case 'amount_with_comma_separator':
          // Ex. 1.134,65
          return formatWithDelimiters(cents, 2, '.', ',')
        case 'amount_no_decimals_with_comma_separator':
          // Ex. 1.135
          return formatWithDelimiters(cents, 0, '.', ',')
        case 'amount_with_apostrophe_separator':
          // Ex. 1'134.65
          return formatWithDelimiters(cents, 2, "'", '.')
        case 'amount_no_decimals_with_space_separator':
          // Ex. 1 135
          return formatWithDelimiters(cents, 0, ' ')
        case 'amount_with_space_separator':
          // 1 134,65
          return formatWithDelimiters(cents, 2, ' ', ',')
        case 'amount_with_period_and_space_separator':
          // 1 134.65
          return formatWithDelimiters(cents, 2, ' ', '.')
        default:
          return match
      }
    })
  }

  // !SECTION: Discount Functions
  price(selling_plan, formatted = true) {
    if (this.rule) {
      return formatted
        ? this.money(this.selectedVariant.price - this.discount(selling_plan).amount - this.selectedVariant.price * (this.rule.discountAmount / 100))
        : this.selectedVariant.price - this.discount(selling_plan).amount - this.selectedVariant.price * (this.rule.discountAmount / 100)
    }

    return formatted ? this.money(this.selectedVariant.price - this.discount(selling_plan).amount) : this.selectedVariant.price - this.discount(selling_plan).amount
  }

  // Updates element data to be registered by forms
  updateForm() {
    let $sellingPlan = this.querySelector('input[name=selling_plan]')

    if ($sellingPlan) {
      $sellingPlan.value = this.selectedSellingPlan ? this.selectedSellingPlan.id : ''
      $sellingPlan.dispatchEvent(new Event('change'))
    }
  }

  // SECTION: Additional Functionality
  updateURLParams() {
    const url = new URL(window.location.href)

    if (this.selectedSellingPlan) {
      url.searchParams.set('selling_plan', this.selectedSellingPlan.id)
      window.history.replaceState({}, '', url.href)
    } else {
      url.searchParams.delete('selling_plan')
      window.history.replaceState({}, '', url.href)
    }
  }

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && {
          selling_plan: this.selectedSellingPlan?.id,
        }),
      },
    ]

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items,
      }),
    })
      .then(response => response.json())
      .then(response => {
        this.log('Added item to cart: ', response)
        //dispatch CustomEvent to tell document that an item was added to cart
        const event = new CustomEvent(`skio::added-to-cart`, {
          bubbles: true,
          composed: true,
          detail: {
            response,
            key: this.key,
          },
        })

        this.dispatchEvent(event)
      })
      .catch(error => {
        this.error(`SKIO ${this.key} error adding item to cart: `, error)
      })
  }

  fetchProduct = handle => {
    return fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(product => {
        this.product = product
        this.selectedVariant = product.variants[0]

        return product
      })
  }
  // !SECTION: Additional Functionality
}

if (!customElements.get('skio-plan-picker')) {
  customElements.define('skio-plan-picker', SkioPlanPicker)
}

if (window) window.SkioPlanPicker = SkioPlanPicker